<template>
    <div>
        <template v-if="exibir_tempos && marcacao">
            <div class="modal fade" :id="'exibirTemosModal' + marcacao.id_marcacao" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">
                                {{ only_rastro ? 'Rastreabilidade' : 'Tempo de Atendimento' }}:  
                                {{ marcacao.nome_paciente }}
                                <span v-if="marcacao.id_atendimento" class="ml-3">
                                    #{{ marcacao.id_atendimento }}
                                </span>
                            </h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <template v-if="!only_rastro">
                                <div class="lead">
                                    {{ marcacao.procedimento.search }}
                                </div>
                                <div class="mb-3">
                                    {{ marcacao.medico.search }}
                                </div>
                                <p class="alert alert-dark" v-if="!marcacao.fl_adicao_direta">
                                    Agendado para: {{ $util.getFormatDate(marcacao.dt_inicio) }}
                                    {{ marcacao.dt_inicio.substr(11,5) }}
                                </p>

                                <!-- Tempos -->
                                <ul class="list-group mb-3">
                                    <li class="list-group-item d-flex justify-content-between" v-if="tempo_antecedencia">
                                    <span class="text-muted">Chegada com Antecedência:</span> 
                                    <span>
                                        {{ seconds_to_time(tempo_antecedencia) }}
                                        <i class="fas fa-stopwatch fa-fw"></i>
                                    </span>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between list-group-item-warning" v-if="tempo_espera_recepcao">
                                    <span class="text-muted">Espera para recepção:</span>
                                    <span>
                                        {{ seconds_to_time(tempo_espera_recepcao) }}
                                        <i class="fas fa-stopwatch fa-fw"></i>
                                    </span>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between list-group-item-primary" v-if="tempo_atend_recepcao">
                                    <span class="text-muted">Atendimento na recepção:</span> 
                                    <span>
                                        {{ seconds_to_time(tempo_atend_recepcao) }}
                                        <i class="fas fa-stopwatch fa-fw"></i>
                                    </span>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between list-group-item-secondary" v-if="tempo_espera_pre_atend">
                                    <span class="text-muted">Espera para o pré-atendimento:</span> 
                                    <span>
                                        {{ seconds_to_time(tempo_espera_pre_atend) }}
                                        <i class="fas fa-stopwatch fa-fw"></i>
                                    </span>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between list-group-item-danger" v-if="tempo_espera_consultorio">
                                    <span class="text-muted">Espera para o atendimento:</span> 
                                    <span>
                                        {{ seconds_to_time(tempo_espera_consultorio) }}
                                        <i class="fas fa-stopwatch fa-fw"></i>
                                    </span>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between list-group-item-success" v-if="tempo_atend_consultorio">
                                    <span class="text-muted">Atendimento pelo profissional:</span> 
                                    <span>
                                        {{ seconds_to_time(tempo_atend_consultorio) }}
                                        <i class="fas fa-stopwatch fa-fw"></i>
                                    </span>
                                    </li>
                                </ul>

                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th>Evento</th>
                                        <th>Data/Hora</th>
                                        <th class="text-right">Tempo</th>
                                    </tr>
                                    </thead>
                                    <tr v-if="marcacao.dt_inicio_atendimento" class="table-secondary">
                                    <td>
                                        <div>
                                            Marcado
                                        </div>
                                        <small class="text-muted">
                                            {{ marcacao.fl_portal ? 'Auto-agendamento' : '' }}
                                        </small>
                                    </td>
                                    <td>
                                        <div>
                                        {{ $util.getFormatDate(marcacao.dt_inicio_atendimento) }}
                                        </div>
                                        <small class="text-muted">
                                        {{ marcacao.dt_inicio_atendimento.substr(11,8) }}
                                        </small>
                                    </td>
                                    <td></td>  
                                    </tr>
                                    <tr v-if="marcacao.dt_checkin" class="table-warning">
                                    <td>
                                        <div>
                                        Check-In
                                        </div>
                                        <small class="text-muted">
                                        {{ marcacao.st_checkin_origem }}
                                        </small>
                                    </td>
                                    <td>
                                        <div>
                                        {{ marcacao.dt_checkin.substr(11,8) }}
                                        </div>
                                        <small class="text-muted">
                                        {{ $util.getFormatDate(marcacao.dt_checkin) }}
                                        </small>
                                    </td>
                                    <td></td>
                                    </tr>
                                    <template v-if="marcacao.atendimento">
                                        <tr v-for="(progresso, ipx) in marcacao.atendimento.progresso_atendimentos" :key="ipx" :class="cor_tabela(progresso)">
                                            <td>
                                                <div>{{ progresso.etapa_atendimento.st_etapa_atendimento }}</div>
                                                <div class="text-muted">
                                                    <small>
                                                        {{ $util.getFormatDate(progresso.dt_conclusao) }}
                                                    </small>
                                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                    <small v-if="progresso.fila">
                                                        {{ progresso.fila.st_fila_laudo }}
                                                    </small>
                                                    <small v-else>
                                                        {{ 
                                                            progresso.etapa_atendimento.ch_tipo_atendimento == 'R' 
                                                            ? 'Recepção'
                                                            : ( progresso.etapa_atendimento.ch_tipo_atendimento == 'C'
                                                            ? 'Atendimento'
                                                            : '' )  
                                                        }}
                                                    </small>

                                                    <small v-if="progresso.usuario">
                                                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                        {{ progresso.usuario.st_login }}
                                                    </small>
                                                </div>
                                            </td>
                                            <td>
                                            <template v-if="progresso.dt_conclusao">
                                                <div>
                                                <i class="fas fa-play-circle fa-fw mr-1"></i>
                                                {{ progresso.dt_inicio.substr(11,8) }}
                                                </div>
                                                <div>
                                                <i class="fas fa-stop-circle fa-fw mr-1"></i>
                                                {{ progresso.dt_conclusao.substr(11,8) }}
                                                </div>
                                            </template>
                                            </td>
                                            <td class="text-right">
                                            {{ seconds_to_time(progresso.tempo) }}
                                            <i class="fas fa-stopwatch fa-fw"></i>
                                            </td>
                                        </tr>
                                    </template>

                                    <template v-if="marcacao && marcacao.timeline && marcacao.timeline.eventos && marcacao.timeline.eventos.length">
                                        <tr v-for="(evento, ie) in marcacao.timeline.eventos" :key="'ev' + ie" :class="'table-' + evento.cor">
                                            <td>
                                                <div>{{ evento.title }}</div>
                                                <div class="small">{{ evento.subtitle }}</div>
                                            </td>
                                            <td>
                                                <div>
                                                    {{ $util.getFormatDate(evento.data) }}
                                                </div>
                                                <div class="text-muted" v-if="evento.data">
                                                    {{ evento.data.slice(11,19) }}
                                                </div>
                                            </td>
                                            <td></td>
                                        </tr>
                                    </template>
                                </table>
                            </template>

                            <template v-if="marcacao && marcacao.timeline && marcacao.timeline.exames && marcacao.timeline.exames.length">
                                <table class="table table-sm table-hover">
                                    <thead>
                                        <tr class="small">
                                            <th>Exames</th>
                                            <th>Status</th>
                                            <th>Agenda</th>
                                            <th>Check-In</th>
                                            <th>Atend</th>
                                            <th>Prazo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(exame, ie) in marcacao.timeline.exames">
                                            <tr :key="'ex' + ie" v-if="true">
                                                <td class="small">
                                                    <template v-if="exame.rastro && exame.rastro.length">
                                                        <a href="#" @click.prevent="toggle_rastro(exame)" title="Ver rastrabilidade do exame." class="card-link">
                                                            <i class="fa-regular fa-square-plus fa-fw mr-2" v-if="!exame.viewrastro"></i>
                                                            <i class="fa-regular fa-square-minus fa-fw mr-2" v-else></i>
                                                        </a>
                                                    </template>
                                                    {{ exame.title }}
                                                </td>
                                                <td>
                                                    <span :class="'badge badge-' + exame.cor">{{ exame.status }}</span>
                                                </td>
                                                <td class="small">{{ exame.agenda ? exame.agenda.slice(11,16) : '' }}</td>
                                                <td class="small">{{ exame.checkin ? exame.checkin.slice(11,16) : '' }}</td>
                                                <td class="small">{{ exame.atend ? exame.atend.slice(11,16) : '' }}</td>
                                                <td class="small">
                                                    <span v-if="exame.prazo">{{ $util.getFormatDate(exame.prazo) }}</span>
                                                </td>
                                            </tr>
                                            <tr :key="'exr' + ie" v-if="exame.viewrastro"> 
                                                <td colspan="6" class="small text-muted px-3">
                                                    <table class="table table-sm mb-2">
                                                        <thead>
                                                            <tr>
                                                                <th></th>
                                                                <th>Rastreabilidade</th>
                                                                <th>Data/Hora</th>
                                                                <th>Usuário</th>
                                                                <th>Obs</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <template v-for="(rastro, ir) in exame.rastro">
                                                                <tr v-if="true" :class="'table-' + rastro.status_laudo.st_color" :key="'r' + ir">
                                                                    <td>
                                                                        <a href="#" @click.prevent="rastro.doc.fl_ativo = !rastro.doc.fl_ativo" v-if="rastro.id_documento_pre_atendimento && rastro.doc">
                                                                            <i class="fa-solid fa-clipboard-check"></i>
                                                                        </a>
                                                                    </td>
                                                                    <td>{{ rastro.status_laudo ? rastro.status_laudo.search : '?' }}</td>
                                                                    <td>
                                                                        {{ $util.getFormatDate(rastro.created_at) }}
                                                                        {{ rastro.created_at.substr(11,8) }}
                                                                    </td>
                                                                    <td>{{ rastro.usuario ? rastro.usuario.st_login : '' }}</td>
                                                                    <td>{{ rastro.st_obs }}</td>
                                                                </tr>
                                                                <tr v-if="rastro.doc && !rastro.doc.fl_ativo" :key="'rd' + ir">
                                                                    <td colspan="5">
                                                                        <formulario 
                                                                            :value="rastro.doc.js_conteudo"
                                                                            :compact="rastro.doc.fl_compact"
                                                                            mode="view" />
                                                                    </td>
                                                                </tr>
                                                            </template>
                                                        </tbody>
                                                    </table>

                                                    <table class="table table-sm table-hover my-2" v-if="exame.resps && exame.resps.length">
                                                        <thead>
                                                            <tr>
                                                                <th>Responsável</th>
                                                                <th>Classificação</th>
                                                                <th>Data/Hora</th>
                                                                <th>Obs</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(resp, irx) in exame.resps" :key="'resp' + irx">
                                                                <td>
                                                                    {{ resp.usuario ? resp.usuario.st_login : '?' }}
                                                                </td>
                                                                <td>
                                                                    <span v-if="resp.usuario && resp.usuario.js_classes && resp.usuario.js_classes.length">
                                                                        {{ resp.usuario.js_classes.join(', ') }}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    {{ $util.getFormatDate(resp.created_at) }}
                                                                    {{ resp.created_at.substr(11,8) }}
                                                                </td>
                                                                <td>
                                                                    {{ resp.st_obs }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </template>

                            <!-- Sinalizadores -->
                            <template v-if="marcacao && marcacao.timeline && marcacao.timeline.sinalizadores && marcacao.timeline.sinalizadores.length">
                                <table class="table table-sm table-hover">
                                    <thead>
                                        <tr>
                                            <th>Outros Eventos</th>
                                            <th>Data/Hora</th>
                                            <th class="text-right">Tempo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(sinal, ie) in marcacao.timeline.sinalizadores" :key="'ex' + ie">
                                            <td>
                                                <i :class="sinal.sinalizador.st_icon + ( sinal.sinalizador.st_cor ? ' text-' + sinal.sinalizador.st_cor : '' )" class="fa-fw mr-2"></i>
                                                {{ sinal.sinalizador ? sinal.sinalizador.search : '?' }}
                                                <span v-if="sinal.id_laudo_sinalizador" class="small text-muted ml-2">
                                                    {{ sinal.sigla ? sinal.sigla : '(L)' }}
                                                </span>
                                                <span v-if="sinal.st_obs" class="small text-muted ml-2">
                                                    {{ sinal.st_obs }}
                                                </span>
                                            </td>
                                            <td>
                                                <div v-if="sinal.created_at">
                                                    <i class="fas fa-play-circle fa-fw mr-1"></i>
                                                    {{ $util.getFormatDate(sinal.created_at) }}
                                                    {{ sinal.created_at.substr(11,8) }}
                                                    <span class="small text-muted ml-2" v-if="sinal.usuario">{{ sinal.usuario.st_login }}</span>
                                                </div>
                                                <div v-if="sinal.updated_at && sinal.updated_at != sinal.created_at">
                                                    <i class="fas fa-stop-circle fa-fw mr-1"></i>
                                                    {{ $util.getFormatDate(sinal.updated_at) }}
                                                    {{ sinal.updated_at.substr(11,8) }}
                                                    <span class="small text-muted ml-2" v-if="sinal.usuario_fim">{{ sinal.usuario_fim.st_login }}</span>
                                                </div>    
                                            </td>
                                            <td class="text-right">
                                                <span v-if="sinal.tempo">
                                                    {{ sinal.tempo }} <i class="fas fa-stopwatch fa-fw"></i>
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </template>

                            <!-- Amostras -->
                            <template v-if="marcacao && marcacao.timeline && marcacao.timeline.amostras">
                                <table class="table table-sm table-hover">
                                    <thead>
                                        <tr>
                                            <th>Amostras</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(amostras, status, ie) in marcacao.timeline.amostras">
                                            <tr v-if="true" :key="'ex' + ie">
                                                <td>
                                                    <a href="#" @click.prevent="amostras[0].fl_ativo = !amostras[0].fl_ativo" class="card-link">
                                                        <i class="fa fa-plus-square-o fa-fw mr-2" aria-hidden="true"></i>
                                                    </a>
                                                    {{ status }}
                                                    <span class="badge badge-secondary ml-2">{{ amostras.length }}</span>
                                                </td>
                                                <td  style="max-width: 200px;">
                                                    <div class="text-nowrap text-truncate small text-muted">
                                                        {{ resumo(amostras[0]) }}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-if="!amostras[0].fl_ativo" :key="'la' + ie">
                                                <td colspan="2">
                                                    <table class="table table-sm">
                                                        <template v-for="(amostra, iax) in amostras">
                                                            <tr v-if="true" :key="iax">
                                                                <td>
                                                                    <a href="#" v-if="amostra.last_rastro && amostra.last_rastro.js_formulario && amostra.last_rastro.js_formulario.length" 
                                                                        @click.prevent="amostra.last_rastro.fl_ativo = !amostra.last_rastro.fl_ativo" class="card-link">
                                                                        <i class="fa-solid fa-clipboard-check"></i>
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    {{ amostra.st_codigo }}
                                                                </td>
                                                                <td>
                                                                    {{ amostra.st_titulo }}
                                                                    <span class="small text-muted ml-2">{{ amostra.st_destino }}</span>
                                                                </td>
                                                                <td>
                                                                    <span v-if="amostra.origem_amostra" class="text-muted ml-2" title="Origem">
                                                                        {{ amostra.origem_amostra.st_titulo }}
                                                                    </span>
                                                                </td>
                                                                <td style="max-width: 200px;">
                                                                    <div v-if="amostra.exames" class="text-nowrap text-truncate">
                                                                        <span v-for="(aap, iaapx) in amostra.exames" :key="iaapx">
                                                                            <span class="badge badge-primary mr-1">
                                                                                {{ aap.atendimento_procedimento.procedimento.st_sigla }}
                                                                            </span>
                                                                            <span v-if="aap.js_classes && aap.js_classes.length" class="small text-muted mx-1">
                                                                                {{ aap.js_classes.join(', ') }}
                                                                            </span>
                                                                        </span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <span v-if="amostra.last_rastro && amostra.last_rastro.created_at" title="Data do Registro" class="small text-muted">
                                                                        {{ $util.getFormatDate(amostra.last_rastro.created_at, 'DD/MM') }}
                                                                        {{ amostra.last_rastro.created_at.slice(11,16) }}
                                                                    </span>
                                                                </td>
                                                            </tr> 
                                                            <tr v-if="amostra.last_rastro && amostra.last_rastro.fl_ativo === false" :key="'form' + iax">
                                                                <td colspan="6">
                                                                    <formulario 
                                                                        :value="amostra.last_rastro.js_formulario"
                                                                        mode="view" />
                                                                </td>
                                                            </tr>
                                                        </template>
                                                    </table>
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </template>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import * as moment from "moment";
import Formulario from '../modulos/consultorio/Formulario.vue';

export default {
    data() {
        return { 
            marcacao: null, 
            exibir_tempos: false, 
        };
    },

    props: ['only_rastro'], 

    components: { 
        Formulario,
    },
    
    computed: { 
        tempo_antecedencia: function () { 
            if ( !this.marcacao || !this.marcacao.atendimento )
                return;

            const inicio = this.marcacao.dt_checkin;
            const fim = this.marcacao.dt_inicio;

            if ( inicio && fim && ( inicio.substr(0,16) == fim.substr(0,16) || inicio > fim ) )
                return;

            return ( inicio && fim ) ? this.calc_tempo(inicio, fim) : null; 
        },

        tempo_espera_recepcao: function () { 
            if ( !this.marcacao || !this.marcacao.atendimento )
                return;

            const inicio = this.marcacao.dt_checkin;
            const progresso = _.first(this.marcacao.atendimento.progresso_atendimentos);
            const fim = progresso 
                ? ( progresso.dt_inicio ? progresso.dt_inicio : progresso.dt_conclusao )
                : "";

            if ( inicio && fim && inicio.substr(0,16) == fim.substr(0,16) )
                return;

            return ( inicio && fim ) ? this.calc_tempo(inicio, fim) : null; 
        },

        tempo_atend_recepcao: function () { 
            if ( !this.marcacao || !this.marcacao.atendimento || !this.marcacao.atendimento.progresso_atendimentos )
                return;

            const tempo = this.marcacao.atendimento.progresso_atendimentos.filter(progresso => progresso.etapa_atendimento.ch_tipo_atendimento == 'R' )
                .reduce((total, carry) => { 
                    return total ? total + parseInt(carry.tempo) : parseInt(carry.tempo);
                }, null);

            return tempo; 
        },

        tempo_espera_pre_atend: function () { 
            if ( !this.marcacao || !this.marcacao.atendimento || !this.marcacao.atendimento.progresso_atendimentos )
                return;

            const tempo = this.marcacao.atendimento.progresso_atendimentos.filter(progresso => progresso.id_etapa_atendimento == 11)
                .reduce((total, carry) => { 
                    return total ? total + parseInt(carry.tempo) : parseInt(carry.tempo);
                }, null);

            return tempo; 
        },

        tempo_espera_consultorio: function () { 
            if ( !this.marcacao || !this.marcacao.atendimento || !this.marcacao.atendimento.progresso_atendimentos )
                return;

            const tempo = this.marcacao.atendimento.progresso_atendimentos.filter(progresso => progresso.id_etapa_atendimento == 5)
                .reduce((total, carry) => { 
                    return total ? total + parseInt(carry.tempo) : parseInt(carry.tempo);
                }, null);

            return tempo; 
        },

        tempo_atend_consultorio: function () { 
            if ( !this.marcacao || !this.marcacao.atendimento || !this.marcacao.atendimento.progresso_atendimentos )
                return;

            const tempo = this.marcacao.atendimento.progresso_atendimentos.filter(progresso => progresso.id_etapa_atendimento == 7 || progresso.id_etapa_atendimento == 9 )
                .reduce((total, carry) => { 
                return total ? total + parseInt(carry.tempo) : parseInt(carry.tempo);
                }, null);

            return tempo; 
        },

    },

    methods: { 
        resumo (amostra) { 
            if ( !amostra || !amostra.last_rastro || !amostra.last_rastro.js_formulario || !amostra.last_rastro.js_formulario.length )
                return '';

            return amostra.last_rastro.js_formulario.filter(campo => campo.value)
                .map(campo => {
                    return `${campo.label}: ${campo.value}`;
                })
                .join(' | ');
        },

        calc_tempo (inicio, fim) { 
            if ( !inicio || !fim )
                return null;

            return moment(fim, "YYYY-MM-DD HH:mm:ss").diff(moment(inicio, "YYYY-MM-DD HH:mm:ss"), 'seconds');
        },

        toggle_rastro (exame) { 
            console.log('toggle', exame);
            exame.viewrastro = !exame.viewrastro;
        },

        abrir (marcacao) { 
            console.log('marc', marcacao);

            this.exibir_tempos = true; 
            this.marcacao = marcacao;

            if ( !this.marcacao ) { 
                this.$toast.add({
                    severity: "success",
                    summary: "Atenção",
                    detail: "Marcação não identificada: " + this.marcacao.id_marcacao,
                    life: 3000
                });
                return; 
            }

            if ( !this.marcacao.timeline ) { 

                this.$util.loadItem(this, { 
                    service: 'marcacoes',
                    func: 'timeline',
                    parms: { 
                        id_marcacao: this.marcacao.id_marcacao,
                    },
                })
                .then(res => { 
                    this.marcacao.timeline = res;

                    if ( res.marcacao && res.marcacao.atendimento && res.marcacao.atendimento.progresso_atendimentos ) { 
                        this.marcacao.atendimento.progresso_atendimentos = res.marcacao.atendimento.progresso_atendimentos;
                    } 

                    this.$forceUpdate();
                });

            } 

            this.$nextTick(() => { 
                $('#exibirTemosModal' + this.marcacao.id_marcacao).modal('show');
            });
        },

        seconds_to_time(seconds) { 
          return new Date(seconds * 1000).toISOString().substr(11, 8);
        },

        cor_tabela (progresso) { 
            if ( progresso.id_etapa_atendimento == 5 ) 
                return 'table-danger';

            if ( progresso.etapa_atendimento.ch_tipo_atendimento == 'R' )
                return 'table-primary';

            if ( progresso.etapa_atendimento.ch_tipo_atendimento == 'C' )
                return 'table-success'; 

            return 'table-secondary';
        },
    }
}
</script>
